<div
  class="hot-toast-loader-icon"
  [style.border-color]="theme()?.primary"
  [style.border-right-color]="theme()?.secondary"
></div>
